import {
  EditorContent,
  useEditor,
  BubbleMenu,
  FloatingMenu,
} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import React, { useCallback, useEffect, useRef, useState } from "react";
import AITextGeneration from "./AIGeneration";
import Modal from "react-bootstrap/Modal";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import Send from "../../assets/Icon/send.svg";
import EditBlue from "../../assets/Icon/Edit-blue.svg";
import Right from "../../assets/Icon/chevron-right.svg";
import { RequestAI } from "./AiApiCall";
import EllipseLoader from "./EllipseLoader";
import Placeholder from "@tiptap/extension-placeholder";
import { languages } from "./AiOptions";
import Close from "../../assets/Icon/close.png";
import AI from "../../assets/Icon/Ask AI.svg";
import Bold from "../../assets/Icon/Bold.svg";
import Italic from "../../assets/Icon/Italic.svg";
import Strike from "../../assets/Icon/strike.svg";
import UnderlineIcon from "../../assets/Icon/Underline.svg";
import TextLeft from "../../assets/Icon/text-align-left.svg";
import TextCenter from "../../assets/Icon/text-align-center.svg";
import TextRight from "../../assets/Icon/text-align-left.svg";
import ImageIcon from "../../assets/Icon/Upload-images.svg";
import LinkIcon from "../../assets/Icon/add-link.svg";
import OrderIcon from "../../assets/Icon/ordered-list-numbers.svg";
import BulletIcon from "../../assets/Icon/bullets.svg";
import ContinueIcon from "../../assets/Icon/Continue writing.svg";
import SpellingIcon from "../../assets/Icon/Fix spelling and grammar.svg";
import LongerIcon from "../../assets/Icon/make longer.svg";
import ShorterIcon from "../../assets/Icon/make shorter.svg";
import Translate from "../../assets/Icon/Translate.svg";
import ReplaceIcon from "../../assets/Icon/replace answer.svg";
import InsertIcon from "../../assets/Icon/Insert below.svg";
import Retry from "../../assets/Icon/retry.svg";
import StopIcon from "../../assets/Icon/stop-button.svg";
import LeftArrow from "../../assets/Icon/arrow-left.svg";
import ChangeTone from "../../assets/Icon/changeTone.svg";

const RichEditor = ({ content, setContent, prompts }) => {
  // console.log("content", content);
  //  console.log("propmts", prompts);
  // const [content, setContent] = useState("");
  const [show, setShow] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [stepper, setStepper] = useState(0);
  const [generatedText, setGeneratedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [intervalId, setIntervalId] = useState(null);
  const [retainedPrompt, setRetainedPrompt] = useState("");
  const inputRef = useRef(null);
  const textEndRef = useRef(null);
  const editorWrapperRef = useRef(null);
  const [disable, setDisable] = useState(false);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
    setGeneratedText("");
    setSelectedText("");

    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);

    const { state, view } = editor;
    const selection = state.selection;
    const selectedText = state.doc.textBetween(
      selection.from,
      selection.to,
      " "
    );
    setSelectedText(selectedText);
    // console.log(selectedText);
    if (selectedText === "") {
      setStepper(4);
    } else {
      setStepper(0);
    }
  };

  // '/' command to used to open modal
  // useEffect(() => {
  // const handleKeyDown = (event) => {
  //   if (event.key === "/") {
  //     // Open the modal when '/' is pressed
  //     handleShow();
  //     setStepper(4);
  //   }
  // setTimeout(() => {
  //   inputRef.current?.focus();
  // }, 100);
  // };
  // // Add event listener for keydown
  // window.addEventListener("keydown", handleKeyDown);
  // // Cleanup event listener on component unmount
  // return () => {
  //   window.removeEventListener("keydown", handleKeyDown);
  // };
  // }, []);

  useEffect(() => {
    if (textEndRef.current) {
      textEndRef.current.scrollTop = textEndRef.current.scrollHeight;
    }
  }, [generatedText]);

  const editor = useEditor({
    extensions: [
      StarterKit,
      AITextGeneration,
      Underline,
      // Placeholder.configure({ placeholder: "Press / for commands" }),
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      Image,
      Link.configure({
        openOnClick: false,
        autolink: true,
        defaultProtocol: "https",
        protocols: ["http", "https"],
        isAllowedUri: (url, ctx) => {
          try {
            // construct URL
            const parsedUrl = url.includes(":")
              ? new URL(url)
              : new URL(`${ctx.defaultProtocol}://${url}`);

            // use default validation
            if (!ctx.defaultValidate(parsedUrl.href)) {
              return false;
            }

            // disallowed protocols
            const disallowedProtocols = ["ftp", "file", "mailto"];
            const protocol = parsedUrl.protocol.replace(":", "");

            if (disallowedProtocols.includes(protocol)) {
              return false;
            }

            // only allow protocols specified in ctx.protocols
            const allowedProtocols = ctx.protocols.map((p) =>
              typeof p === "string" ? p : p.scheme
            );

            if (!allowedProtocols.includes(protocol)) {
              return false;
            }

            // disallowed domains
            const disallowedDomains = [
              "example-phishing.com",
              "malicious-site.net",
            ];
            const domain = parsedUrl.hostname;

            if (disallowedDomains.includes(domain)) {
              return false;
            }

            // all checks have passed
            return true;
          } catch {
            return false;
          }
        },
        shouldAutoLink: (url) => {
          try {
            // construct URL
            const parsedUrl = url.includes(":")
              ? new URL(url)
              : new URL(`https://${url}`);

            // only auto-link if the domain is not in the disallowed list
            const disallowedDomains = [
              "example-no-autolink.com",
              "another-no-autolink.com",
            ];
            const domain = parsedUrl.hostname;

            return !disallowedDomains.includes(domain);
          } catch {
            return false;
          }
        },
      }),
    ],
    content: content,
    onUpdate({ editor }) {
      setContent(editor.getHTML());
    },
  });

  useEffect(() => {
    if (editor) {
      editor.setEditable(true);
    }
  }, [editor]);

  //generate content
  const generateContent = async (type, language = null) => {
    // console.log(prompt);
    if (prompt === "" && type === "generic") {
      setDisable(true);
      return;
    }
    let updatedPromt;
    let userPrompt;
    // if (type === "generic") {
    //   updatedPromt = prompt;
    // }
    // if (type === "continue") {
    //   updatedPromt = `Continue writing from the following text: ${selectedText}`;
    // }
    // if (type === "grammer") {
    //   updatedPromt = `Rewrite from the following content with no spelling mistakes, proper grammar, and with more descriptive language, using best writing practices without losing the original meaning: ${selectedText}`;
    // }
    // if (type === "longer") {
    //   updatedPromt = `Expand from the following content with descriptive language and more detailed explanations, to make the writing easier to understand and increase the length of the content: ${selectedText}`;
    // }
    // if (type === "shorter") {
    //   updatedPromt = `Please rewrite the following content in a shorter, more concise form while keeping the main idea intact: ${selectedText}`;
    // }
    // if (type === "translate" && language) {
    //   updatedPromt = `Translate the following content to ${language} language : ${selectedText}`;
    // }
    // if (type === "tryAgain") {
    //   updatedPromt = `Please try again and generate a different version of the following content, Focus on improving clarity, variety, or creativity while keeping the original intent intact: ${retainedPrompt}`;
    // }
    setDisable(true);
    if (type === "generic") {
      updatedPromt = prompts?.generateText;
      userPrompt = prompt;
    }
    if (type === "continue") {
      updatedPromt = prompts?.continueWriting;
      userPrompt = selectedText;
    }
    if (type === "grammer") {
      updatedPromt = prompts?.fixSpellingGrammer;
      userPrompt = selectedText;
    }
    if (type === "longer") {
      updatedPromt = prompts?.makeLonger;
      userPrompt = selectedText;
    }
    if (type === "shorter") {
      updatedPromt = prompts?.makeShorter;
      userPrompt = selectedText;
    }
    if (type === "tone") {
      updatedPromt = prompts?.changeTone;
      userPrompt = selectedText;
    }
    if (type === "translate" && language) {
      updatedPromt = `${prompts?.translate} which is ${language}`;
      userPrompt = selectedText;
    }
    if (type === "tryAgain") {
      updatedPromt = prompts?.tryAgain;
      userPrompt = retainedPrompt;
    }
    setLoading(true);
    // console.log(updatedPromt);
    if (updatedPromt && userPrompt) {
      await RequestAI(updatedPromt, userPrompt)
        .then((res) => {
          // console.log("res", res);
          // setGeneratedText("");
          setRetainedPrompt(userPrompt);
          const formattedText = res.replace(/\n/g, "<br/>");
          let words = formattedText.split(" ");
          let index = 0;
          let tempText = "";

          const id = setInterval(() => {
            // if (stepper === 3) {
            //   console.log("check", stepper)
            //   clearInterval(id);
            //   return;
            // }
            // console.log(index, words)
            if (index < words.length) {
              tempText += words[index] + " ";
              setGeneratedText(tempText);
              index++;
              setStepper(2);
            } else {
              clearInterval(id);
              setStepper(3);
            }
          }, 100);

          setIntervalId(id);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
          setPrompt("");
          setStepper(3);
          setDisable(false);
          // setRetainedPrompt("");
        });
    }
  };

  const handleChange = (e) => {
    setPrompt(e.target.value);
    setDisable(false);
  };

  //Inser below
  const handleInsert = () => {
    // const endPosition = editor.state.doc.content.size;
    // editor.commands.insertContentAt(endPosition, generatedText);
    const docSize = content;
    // console.log("docsize", docSize, editor);
    // console.log(generatedText);
    const cleanedHTML = generatedText.replace(/<p>(\s|&nbsp;| )*<\/p>/g, "");
    if (docSize.length === 0) {
      editor.commands.setContent(cleanedHTML);
    } else {
      const endPosition = editor.state.doc.content.size;
      editor.commands.insertContentAt(endPosition, cleanedHTML);
    }
    handleClose();
  };

  //handleReplace
  const handleReplace = () => {
    // console.log(generatedText);
    editor.commands.insertContent(generatedText);
    handleClose();
  };

  //handle stop generation
  const stopGenerating = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setStepper(3);
    }
  };

  //add image
  const addImage = useCallback(() => {
    const url = window.prompt("URL");

    if (url) {
      editor.chain().focus().setImage({ src: url }).run();
    }
  }, [editor]);

  //add link
  const setLink = useCallback(() => {
    const previousUrl = editor.getAttributes("link").href;
    const url = window.prompt("URL", previousUrl);

    // cancelled
    if (url === null) {
      return;
    }

    // empty
    if (url === "") {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
      return;
    }

    // update link
    try {
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run();
    } catch (e) {
      alert(e.message);
    }
  }, [editor]);

  return (
    <>
      {editor && (
        // <BubbleMenu editor={editor} tippyOptions={{ duration: 100 }}>
        <div className="bubble-menu">
          <div className="bubble-menu-1">
            <button onClick={() => handleShow()}>
              <img src={AI} alt="ai" />
            </button>
          </div>
          <div className="bubble-menu-1">
            <button
              onClick={() => editor.chain().focus().toggleBold().run()}
              className={editor.isActive("bold") ? "is-active" : ""}
            >
              <img src={Bold} alt="bold" />
            </button>
            <button
              onClick={() => editor.chain().focus().toggleItalic().run()}
              className={editor.isActive("italic") ? "is-active" : ""}
            >
              <img src={Italic} alt="italic" />
            </button>
            <button
              onClick={() => editor.chain().focus().toggleUnderline().run()}
              className={editor.isActive("underline") ? "is-active" : ""}
            >
              <img src={UnderlineIcon} alt="underline" />
            </button>
            <button
              onClick={() => editor.chain().focus().toggleStrike().run()}
              className={editor.isActive("strike") ? "is-active" : ""}
            >
              <img src={Strike} alt="strike" />
            </button>
          </div>
          <div className="bubble-menu-1">
            <button
              onClick={() => editor.chain().focus().setTextAlign("left").run()}
              className={
                editor.isActive({ textAlign: "left" }) ? "is-active" : ""
              }
            >
              <img src={TextLeft} alt="left" />
            </button>
            <button
              onClick={() =>
                editor.chain().focus().setTextAlign("center").run()
              }
              className={
                editor.isActive({ textAlign: "center" }) ? "is-active" : ""
              }
            >
              <img src={TextCenter} alt="center" />
            </button>
            <button
              onClick={() => editor.chain().focus().setTextAlign("right").run()}
              className={
                editor.isActive({ textAlign: "right" }) ? "is-active" : ""
              }
            >
              <img src={TextRight} alt="right" />
            </button>
          </div>
          <div className="bubble-menu-1">
            <button
              onClick={() => editor.chain().focus().toggleOrderedList().run()}
              className={editor.isActive("orderedList") ? "is-active" : ""}
            >
              <img src={OrderIcon} alt="right" />
            </button>
            <button
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              className={editor.isActive("bulletList") ? "is-active" : ""}
            >
              <img src={BulletIcon} alt="right" />
            </button>
          </div>
          <div className="">
            <button onClick={addImage}>
              <img src={ImageIcon} alt="right" />
            </button>
            <button
              onClick={setLink}
              className={editor.isActive("link") ? "is-active" : ""}
            >
              <img src={LinkIcon} alt="right" />
            </button>
          </div>
        </div>
        // </BubbleMenu>
      )}

      <EditorContent editor={editor} />

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ai-custom-modal"
        size="lg"
      >
        <Modal.Body>
          {loading ? (
            <div className="p-4">
              <EllipseLoader />
            </div>
          ) : (
            <div
              className={`${
                generatedText !== "" && "p-3 ai-generated-text"
              } d-flex justify-content-between`}
              ref={textEndRef}
            >
              <div dangerouslySetInnerHTML={{ __html: generatedText }}></div>
              {generatedText !== "" && (
                <div style={{ cursor: "pointer" }}>
                  <img
                    src={Close}
                    alt="Close"
                    className="svg-icon"
                    onClick={() => {
                      handleClose();
                    }}
                    height={20}
                    width={20}
                  />
                </div>
              )}
            </div>
          )}
          {stepper === 4 ? (
            <div className="d-flex w-100 align-items-center input-style">
              <div style={{ width: "100%" }}>
                {" "}
                <input
                  type="text"
                  className="form-control"
                  value={prompt}
                  onChange={handleChange}
                  placeholder="Ask AI to generate"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      generateContent("generic");
                    }
                  }}
                  ref={inputRef}
                />
              </div>
              <button
                style={{ backgroundColor: "transparent" }}
                className="m-2"
                onClick={() => generateContent("generic")}
                disabled={disable}
              >
                <img src={Send} alt="img" />
              </button>
            </div>
          ) : (
            <></>
          )}
          {stepper === 0 ? (
            <div className="ai-options">
              <div onClick={() => generateContent("continue")}>
                <img
                  src={ContinueIcon}
                  alt="countine"
                  className="me-2"
                  width={18}
                />{" "}
                Continue Writing
              </div>
              <div onClick={() => generateContent("grammer")}>
                <img
                  src={SpellingIcon}
                  alt="countine"
                  className="me-2"
                  width={18}
                />{" "}
                Fix Spelling And Grammer
              </div>
              <div onClick={() => generateContent("longer")}>
                <img
                  src={LongerIcon}
                  alt="longer"
                  className="me-2"
                  width={18}
                />{" "}
                Make Longer
              </div>
              <div onClick={() => generateContent("shorter")}>
                <img
                  src={ShorterIcon}
                  alt="shorter"
                  className="me-2"
                  width={18}
                />{" "}
                Make Shorter
              </div>
              <div onClick={() => generateContent("tone")}>
                <img
                  src={ChangeTone}
                  alt="shorter"
                  className="me-2"
                  width={18}
                />{" "}
                Change Tone
              </div>
              <div
                className="d-flex justify-content-between"
                onClick={() => setStepper(1)}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={Translate}
                    alt="img"
                    className="me-2"
                    width={15}
                    height={18}
                  />{" "}
                  <div>Translate</div>
                </div>
                <div>
                  <img src={Right} alt="img" />
                </div>
              </div>
            </div>
          ) : stepper === 1 ? (
            <div className="ai-options">
              <div onClick={() => setStepper(0)}>
                <img
                  src={LeftArrow}
                  alt="img"
                  className="me-2"
                  width={15}
                  height={18}
                />
                Back
              </div>
              {languages.map((item, index) => (
                <div
                  key={index}
                  onClick={() => generateContent("translate", item)}
                >
                  <img
                    src={Translate}
                    alt="img"
                    className="me-2"
                    width={15}
                    height={18}
                  />
                  Translate to {item}
                </div>
              ))}
            </div>
          ) : stepper === 2 ? (
            <div className="ai-options">
              <div onClick={stopGenerating}>
                <img src={StopIcon} alt="img" className="me-2" width={18} />{" "}
                Stop Generating
              </div>
            </div>
          ) : stepper === 3 ? (
            <div className="ai-options">
              <div onClick={handleReplace}>
                <img src={ReplaceIcon} alt="img" className="me-2" width={18} />{" "}
                Replace With This Answer
              </div>
              <div onClick={handleInsert}>
                <img src={InsertIcon} alt="img" className="me-2" width={18} />{" "}
                Insert Below
              </div>
              <div onClick={() => generateContent("tryAgain")}>
                <img src={Retry} alt="img" className="me-2" width={13} style={{marginLeft:'3px'}}/> Try
                Again
              </div>
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RichEditor;
